import { Button, Stack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { DataTable } from '../../components/Table/DataTable';
import useChainQuery from '../../hooks/useChainQuery';
import { ContentCard } from '../../layout/ContentCard';

const ChainUsersOverviewCard = (props: { chainId: number }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { chainId } = props;

  const chainQuery = useChainQuery(chainId);

  const columns = useMemo(
    () => [
      {
        Header: t('forms:id.label'),
        accessor: 'id',
      },
      {
        Header: t('workshop:email.label'),
        accessor: 'email',
      },
      {
        Header: t('workshop:firstname.label'),
        accessor: 'firstname',
      },
      {
        Header: t('workshop:lastname.label'),
        accessor: 'lastname',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chainQuery.data?.users],
  );
  if (chainQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <ContentCard isLoading={chainQuery.isFetching} minH="fit-content" header={t('workshop:users.header')} data-test-id="users-overview-card">
      <Button
        mb={10}
        onClick={() => {
          navigate(`/app/op/invite-chain-manager/${chainId}`);
        }}
        variant="primary"
      >
        {t('pages:chains.chain_manager.invite')}
      </Button>
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w="full">
          <DataTable
            data-test-id="users-table"
            data={chainQuery.data?.users as unknown as any[]}
            hasFilters={false}
            columns={columns}
            loading={chainQuery.isFetching}
            isMoreThenOnePage={false}
            hasSearchInput={undefined as any}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default ChainUsersOverviewCard;
